import UserContext from '../common/decorators/UserContext';
import Router, { withRouter } from 'next/router';
import '../project/stylesToApp.scss';
import 'react-dropdown/style.css';
import 'react-phone-input-2/lib/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import { AdminFontStyle, DefaultFontStyle, OfficeFontStyle, PrataFontStyle } from '../project/uikit/fonts';
import ProtectedOffice from '../common/decorators/ProtectedOffice';
import ProtectedAdmin from '../common/decorators/ProtectedAdmin';
import useTheme from '../common/utils/useTheme';
import { useEffect, useState } from 'react';
import * as React from 'react';
import moment from 'moment';
import { existMoment } from '../common/utils/dateLocales';

const App = ({ Component, pageProps }) => {
    const { protect, protectRoles, onlyForRoles } = pageProps;
    const getLayout = Component.getLayout || ((page) => page);
    useTheme(protect);

    useEffect(() => {
        if (existMoment[pageProps.lang]) {
            try {
                import(`moment/locale/${existMoment[pageProps.lang]}`).then(() => {
                    moment.locale(pageProps.lang);
                });
            } catch {
                console.error('Error loading moment');
            }
        }
    }, [pageProps]);
    useEffect(() => {
        const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
        let isSafari =
            /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
            /constructor/i.test(window.HTMLElement) ||
            (function (p) {
                return p.toString() === '[object SafariRemoteNotification]';
            })(
                !window['safari'] ||
                    // eslint-disable-next-line no-undef
                    (typeof safari !== 'undefined' && safari.pushNotification)
            );

        const mobile = Boolean(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent));
        if (!mobile) {
            if (isSafari) {
                const version = navigator.userAgent.split('Version/')[1].split(' ')[0].split('.')[0];
                if (Number(version)) {
                    document.documentElement.dataset.browserVersion = Number(version) > 14 ? Number(version) : '14';
                }
            }
        }

        document.documentElement.dataset.browser = isSafari ? 'Safari' : 'Webkit';
    }, []);
    useEffect(() => {
        const handleRouteChangeError = (err) => {
            if (err.cancelled) {
                console.log('Route change was cancelled!');
            }
        };

        Router.events.on('routeChangeError', handleRouteChangeError);

        return () => {
            Router.events.off('routeChangeError', handleRouteChangeError);
        };
    }, []);

    const [layoutProps, setLayoutProps] = useState({});
    return (
        <>
            {protect === 'admin' ? (
                <>
                    <AdminFontStyle />
                    <ProtectedAdmin role={protectRoles}>
                        {getLayout(<Component {...pageProps} setLayoutProps={setLayoutProps} />, pageProps, layoutProps)}
                    </ProtectedAdmin>
                </>
            ) : protect === 'office' || protect === 'confirm-presence' ? (
                <>
                    <OfficeFontStyle />
                    <ProtectedOffice onlyForRoles={onlyForRoles} confirmPresence={protect === 'confirm-presence'}>
                        {getLayout(<Component {...pageProps} setLayoutProps={setLayoutProps} />, pageProps, layoutProps)}
                    </ProtectedOffice>
                </>
            ) : (
                <>
                    <DefaultFontStyle />
                    <PrataFontStyle />
                    {getLayout(<Component {...pageProps} setLayoutProps={setLayoutProps} />, pageProps, layoutProps)}
                </>
            )}
        </>
    );
};
const FallbackPages = (OriginalComponent) =>
    class WrapperComponent extends React.Component {
        constructor(params) {
            super(params);
        }

        render() {
            if (this.props.router.isFallback) return null;
            return <OriginalComponent {...this.props} />;
        }
    };
export default withRouter(FallbackPages(UserContext(App)));
